
    import Vue from 'vue';  

    export default Vue.extend({
        name: "AlertConfirmModal",
        data: () => ({
            isVisible: false
        }),
        methods: {
            open() {
                this.isVisible = true
            },
            close() {
                this.isVisible = false
            }
        }
    });
